import { render, staticRenderFns } from "./sensoryReportList.vue?vue&type=template&id=4def9c50&scoped=true"
import script from "./sensoryReportList.vue?vue&type=script&lang=js"
export * from "./sensoryReportList.vue?vue&type=script&lang=js"
import style0 from "./sensoryReportList.vue?vue&type=style&index=0&id=4def9c50&scoped=true&lang=scss"
import style1 from "./sensoryReportList.vue?vue&type=style&index=1&id=4def9c50&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4def9c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4def9c50')) {
      api.createRecord('4def9c50', component.options)
    } else {
      api.reload('4def9c50', component.options)
    }
    module.hot.accept("./sensoryReportList.vue?vue&type=template&id=4def9c50&scoped=true", function () {
      api.rerender('4def9c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory2/sensory-report/sensoryReportList.vue"
export default component.exports